import type { ZudokuConfig, ZudokuPlugin } from "zudoku";
import './src/styles/global.css';

import LockedLoaderImage from "./src/shared/ui/data_display/locked_loader_image";
// import { navigation } from "./src/app/config/navigation/navigation";



const config: ZudokuConfig = {
  docs: {
    files: "pages/**/*.{md,mdx}", // Our markdown files
    publishMarkdown: true, // Generate .md files
    llms: {
      llmsTxt: true, // Generate llms.txt
      llmsTxtFull: true, // Generate llms-full.txt
      includeProtected: false, // Exclude protected routes
    },

    defaultOptions: {
      suggestEdit: {
        url: "https://twitblit.ru/supports/questions/create",
        text: "Задать вопрос или сообщить об ошибке",
      }
    }
  },

  site: {
    logo: {
      src: { light: "/logo-light.svg", dark: "/logo-dark.svg" },
      alt: "Twitblit — social network and developer platform",
      width: "35px",
      href: 'https://twitblit.ru',
    },

    showPoweredBy: false,

    footer: {
      copyright: (() => {
        const year = new Date().getFullYear();

        return year === 2026
          ? `© 2026 Twitblit. Все права защищены. ИП Кузмичёв Владислав Денисович`
          : `© 2026-${year} Twitblit. Все права защищены. ИП Кузмичёв Владислав Денисович`;
      })(),

      social: [
        {
          icon: <LockedLoaderImage src="/icons/brands/social/ic_telegram.png" alt="Twitblit в Telegram" width={24} height={24} />,
          href: "https://t.me/twitblit",
        }
      ]
    },

  },

  metadata: {
    applicationName: "Twitblit",
    generator: "Zudoku",
    authors: ["Twitblit"],
    creator: "Twitblit",
    publisher: "Twitblit",
    keywords: [
      // Brand
      "Twitblit",
      "Twitblit API",
      "Twitblit Documentation",
      "Twitblit Developers",
      "Twitblit Platform",

      // Core positioning
      "Content Protection",
      "Protected Social Network",
      "Original Content Platform",
      "Creator Platform",
      "Author Platform",
      "Content Ownership",
      "Digital Content Ownership",
      "Content Authenticity",
      "Verified Original Content",
      "Proof of Authorship",
      "Content Provenance",

      // AI positioning
      "AI-safe Content",
      "AI-resistant Content",
      "Content Protection Against AI Training",
      "Protect Content from AI",
      "Prevent AI Scraping",
      "Anti AI Scraping",
      "Anti Scraping Platform",
      "AI Content Protection",
      "LLM-safe Content",
      "Ethical AI Data Usage",

      // Social platform
      "Microblogging Platform",
      "Social Publishing Platform",
      "Social Network for Creators",
      "Publishing Platform",
      "Creator Economy",
      "Independent Creators",

      // Developer
      "Developer API",
      "REST API",
      "OpenAPI",
      "Webhooks",
      "OAuth",
      "API Documentation",
      "Developer Documentation",
      "SDK",
      "Authentication",

      // Integrations
      "Social Media API",
      "Content API",
      "Creator API",
      "Publishing API",
      "Web API",

      // AI ecosystem
      "LLM Integrations",
      "AI Agents",
      "Model Context Protocol",
      "MCP",
      "Agentic Applications"
    ],

    defaultTitle: "Документация Twitblit для пользователей и разработчиков",
    favicon: "/icons/icon-512x512.png",

  },

  // search: {
  //   type: "pagefind",
  //   // Optional: Maximum number of sub results per page
  //   maxSubResults: 3,
  //   // Optional: Configure search result ranking (defaults shown below)
  //   ranking: {
  //     termFrequency: 0.8,
  //     pageLength: 0.6,
  //     termSimilarity: 1.2,
  //     termSaturation: 1.2,
  //   },
  // },


  theme: {
    light: {
      primary: '#5f18da'
    },
    dark: {
      primary: '#5f18da'
    }
  },

  // Редиректы с информационных страниц на главную
  redirects: [
    { from: '/about', to: '/' },
    { from: '/about/', to: '/' },
    { from: '/o-nas', to: '/' },
    { from: '/o-nas/', to: '/' },
    { from: '/about-us', to: '/' },
    { from: '/about-us/', to: '/' },
  ],

  navigation: [
    // Документация пользователей
    {
      type: "category" as const,
      label: "Документация пользователей",
      items: [
        { type: "filter", placeholder: "Найти интересное" },

        // Начальная страница документации
        {
          type: "doc",
          icon: "info",
          file: "ru/users/introduction.mdx",
          path: '/',
          label: "О Twitblit"
        },

        {
          type: "category" as const,
          icon: "scale",
          label: "Политики и юридические документы",
          // link: "ru/users/legal/introduction.mdx",
          items: [
            {
              "type": "doc",
              "file": "ru/users/legal/privacy-policy.mdx",
              "label": "Политика конфиденциальности",
              "icon": "file-text"
            },
            {
              "type": "doc",
              "file": "ru/users/legal/terms-of-use.mdx",
              "label": "Пользовательское соглашение",
              "icon": "file-text"
            },
            {
              "type": "doc",
              "file": "ru/users/legal/cookie-policy.mdx",
              "label": "Политика использования cookie",
              "icon": "cookie"
            },
            {
              "type": "doc",
              "file": "ru/users/legal/community-guidelines.mdx",
              "label": "Правила сообщества и модерации",
              "icon": "shield-check"
            },
            {
              "type": "doc",
              "file": "ru/users/legal/recommendation-tech.mdx",
              "label": "Рекомендательные технологии",
              "icon": "sparkles",
            },
          ],
        },
      ],
    },

    // Документация разработчиков
    {
      type: "category" as const,
      label: "Документация разработчиков",
      items: [
      ],
    },

    // Twitblit SDK
    {
      type: "category" as const,
      label: "Twitblit SDK",
      items: [
      ],
    },

    // Twitblit API
    {
      type: "category" as const,
      label: "Twitblit API",
      items: [
      ],
    }
  ],


  sitemap: {
    // The base url for your site
    // Required
    siteUrl: "https://help.twitblit.ru",
    // The change frequency for the pages
    // Defaults to daily
    changefreq: "daily",
    // The priority for the pages
    // Defaults to 0.7
    priority: 0.7,
    // The output directory for the sitemap
    // Defaults to undefined
    outDir: "sitemaps/",
    // Whether to include the last modified date
    // Defaults to true
    autoLastmod: true,
    // The pages to exclude from the sitemap
    // Can also be a function that returns an array of paths
    // () => Promise<string[]>
    exclude: ["/404", "/private/page"]
  },

  plugins: [
    {
      getHead: () => (
        <>
          <script
            defer
            src="https://metrics.twitblit.ru/blit-metrics"
            data-website-id="51561e93-e0f9-402e-a186-eac65e433b9d"
            data-auto-track="true"
          />
          <script
            defer
            src="https://metrics.twitblit.ru/recorder.js"
            data-website-id="51561e93-e0f9-402e-a186-eac65e433b9d"
          />
        </>
      ),
    } satisfies ZudokuPlugin,
  ],

};

export default config;
